// extracted by mini-css-extract-plugin
export default {"content":"Teg6E","button":"q1lZv","icon":"YdIEi","title":"bLh4d","subtitle":"cZbBS"};